import PostDetails from "../../../components/feed/PostDetails";

const PostPage = () => {
    return (
        <PostDetails />
    )
} 

export default PostPage;